import React from "react";
import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  HeadingStyled,
  LazyImage,
  // LazyImage,
  TextStyled,
} from "../../../components/styled/Elements";
import { ForgetPassEmail } from "../../../components/styled/AllImages";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ForgetEmailSentModal = (props) => {
    const {t} = useTranslation()
    const navigate = useNavigate();
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Box className="d-flex flex-column align-items-center py-3 px-2">
          <Box>
            <LazyImage src={ForgetPassEmail} />
          </Box>
          <Box>
            <HeadingStyled size="24px" className="mb-2 mt-3">
              {t("check_your_email")}
            </HeadingStyled>
          </Box>
          <Box>
            <TextStyled
              size="16px"
              color="var(--lightGrey)"
              className="text-center px-3 mb-2"
            >
              {t("we_emailed_you_instructions_to_reset_pass")}
            </TextStyled>
          </Box>
          <FormButtonStyled
            label={t("ok")}
            className="w-100"
            clName="w-100"
            onClick= {props.onHide}
          />
          
        </Box>
      </Modal.Body>
    </Modal>
  );
};

export default ForgetEmailSentModal;
